// DEPENDENCIES
import React from 'react';
import PropTypes from 'prop-types';

import SVGInline from 'react-svg-inline'

// INNER IMPORTS
import './ProfileBar.css';

const ProfileBar = props => (
  <div className="profileBar rtl">
      <div className="topStripe"></div>
      <div className="content">
        <div className="profileImage">
            <SVGInline className="avatar_img" svg={props.profileImage} component="i"/>
            {/*<img src={props.profileImage} alt="profile"/>*/}
        </div>
          <div className="username">
              {props.userName}
          </div>
      </div>
  </div>
);

ProfileBar.propTypes = {
    profileImage: PropTypes.string,
    userName: PropTypes.string
};

export default ProfileBar;



// WEBPACK FOOTER //
// ./src/Components/Users/ProfileBar.js